import { RichTextEditor as MantineRichTextEditor, RichTextEditorLinkControlProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";
import { useEditorDisabled } from "../use-editor-disabled";

export const Link: FunctionComponent<RichTextEditorLinkControlProps> = ({ className, disabled, ...other }) => {
    const effectiveDisabled = useEditorDisabled(disabled);
    return (
        <MantineRichTextEditor.Link
            classNames={{ control: clsx(styles["control"], className) }}
            disabled={effectiveDisabled}
            {...other}
        />
    );
};

Link.displayName = "RichTextEditor.Link";
